import React, { useState } from 'react';

import './Users.user.scss';
import { PatientAvatar as UserAvatar } from '../visuals/Patient.avatar';
import ItemMenu from '../forms/menu/MenuComponent';
import {useNavigate} from 'react-router-dom';
import UserDisableModal from './detail/User.deactivate.dialog';
import { Subject } from 'rxjs';
import {getDateFormat} from "../utils/date";
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";



function UserBaseUser({ currentOrg, clinician, selected, onSelected, propagateUserChange }) {
    const {t} = useTranslation(['users'])
    const ROLE_OPTIONS = [
        { label: t('administrator'), value: 'admin' },
        { label: t('clinician'), value: 'clinician' },
        { label: t('staff'), value: 'staff' },
        { label: t('read-only'), value: 'read' },
        { label: t('command-only'), value: 'command-only' }
    ];
    const [disableRequested, setDisableRequested] = useState(false);
    const [closeMenuSubject] = useState(new Subject());

    const navigate = useNavigate();

    const handleClick = () => {
        AuditTrail.sendLog(PAGES.USERS_LIST, {tag: 'row', event: 'onClick', action: 'click row patient', user_id: clinician._id});
        onSelected(clinician)
    }
    const goToEditPatient = () => {
        AuditTrail.sendLog(PAGES.USERS_LIST, {tag: 'button', event: 'onClick', action: 'click option edit user', user_id: clinician._id});
        navigate(`/users/edit/${clinician._id}`);
    }
    const goToViewPatient = () => {
        AuditTrail.sendLog(PAGES.USERS_LIST, {tag: 'button', event: 'onClick', action: 'click option detail user', user_id: clinician._id});
        navigate(`/users/view/${clinician._id}`);
    }
    const closeDisable = () => {
        setDisableRequested(false);
        closeMenuSubject.next(true);
    }

    const closeDisableModified = (user) => {
        propagateUserChange(user);
        setDisableRequested(false);
        closeMenuSubject.next(true);
    }

    const openDisable = () => {
        setDisableRequested(true);
    }
    const roleLabel = (clinician.role && ROLE_OPTIONS.find(ro => ro.value === clinician.role)) || { label: t('read-only') };
    const phone = clinician.phones.find(ph => ph.label === t('mobile')) || clinician.phones[0];
    const getPhone = (phone) => {
        if (!phone || !phone.number) {
            return '--';
        }
        if (phone.number.search(/\+/) !== -1) {
                return phone.number;
            }
        return '+' + phone.code + ' ' + phone.number;
    }
    return (
        <div className={`__UsersBaseUser ${selected ? 'selected' : ''}`} onClick={handleClick}>
            <UserDisableModal  clinician={clinician} disableRequested={disableRequested} closeDisable={closeDisable} closeUpdateDisabled={closeDisableModified}/>
            <UserAvatar bio={clinician.user.bio} small={true} programId={clinician.programId} status={clinician.user.isDisabled ? 'disenrolled' : null}/>
            <div className="name">
                <h3 onClick={goToViewPatient}>
                    {clinician.user.bio.lastname}, {clinician.user.bio.firstname}
                </h3>
                {
                    clinician.isNew ?
                        <div className="_isNew">
                            {t('new').toUpperCase()}
                    </div>
                        : ''
                }
            </div>

            <p>
                {
                    getPhone(phone)
                }
            </p>
            <p>
                {roleLabel.label}
            </p>
            <p>
                {getDateFormat(currentOrg, clinician.dateOfBirth, 'short')}
            </p>
            <div>
                <ItemMenu actionWillRedirect={true} forceCloseSubject={closeMenuSubject} fixed={true}
                          label={'Participant Options'} event={PAGES.USERS_LIST} eventParams={{user_id: clinician._id}} >
                    <>
                        <div className="_option" onClick={goToEditPatient}>
                            <p>{t('edit-user')}</p>
                        </div>
                        <div className="_option" onClick={goToViewPatient}>
                            <p>{t('user-details')}</p>
                        </div>
                        <div className="_option" onClick={openDisable}>
                           <p>{!!clinician && clinician.user.isDisabled ? t('set-as-active') : t('set-as-inactive')}</p>
                        </div>
                    </>
                </ItemMenu>
            </div>
        </div>
    )
}

export default UserBaseUser;
